import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { moveItemInArray } from "@angular/cdk/drag-drop";
import { wsExportMapFileRequest } from "../shared/wsExportMapFileRequest";
import { DataService_photoexport } from "../shared/data.service";

@Component({
	selector: "app-export-map-file-dialog",
	templateUrl: "./export-map-file-dialog.component.html",
	styleUrls: ["./export-map-file-dialog.component.css"],
})
export class ExportMapFileDialogComponent implements OnInit {
	constructor(
		private dialogConfig: DynamicDialogConfig,
		private ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		private dataService: DataService_photoexport
	) {}

	ngOnInit(): void {
		this.Mode = this.dialogConfig.data.Mode;
		this.SelectedSchool = this.dialogConfig.data.SelectedSchool;
		this.SchoolName = this.SelectedSchool.SchoolName;

		if (this.dialogConfig.data.SelectedStudentGroup != undefined) {
			this.SelectedStudentGroup = this.dialogConfig.data.SelectedStudentGroup;
			this.StudentGroupName = this.SelectedStudentGroup.GroupName;
		}

		this.loadExportColumns();
		this.loadExampleData();
	}

	////////////////////////////////////////////////////////////
	// Data
	////////////////////////////////////////////////////////////

	Mode: string = "Student"; //Student | Staff
	SelectedSchool: any;
	SchoolName: string = "";
	SelectedStudentGroup: any;
	StudentGroupName: string = "";

	lstExportColumns: any = [];
	lstVisibleExportColumns: any = [];

	ExamplePageRows: number = 5;
	ExamplePageFirst: number = 0;
	lstExampleData: any = [];
	lstExFirstName = ["John", "Jane", "Mike", "Mary", "Adam", "Seth", "Sara", "Kennedy", "Deandre", "Tracy", "Jasmine", "Mitchell"];
	lstExLastName = ["Smith", "Jefferson", "Johnson", "Miller", "Oates", "Young", "Calderon", "Addison", "Scott", "Roberts"];
	lstExStaffTitle = ["Staff", "Teaching Assistant", "Administrator", "Security Officer", "Office Assistant", "Custodian", "Secretary", "Sub"];

	FileTypeID: number = 1;
	lstFileType: any = [
		{
			ID: 1,
			Desc: ".txt, Tab-Delimited",
		},
		{
			ID: 2,
			Desc: ".txt, Comma-Delimited",
		},
		{
			ID: 3,
			Desc: ".csv",
		},
	];

	Processing: boolean = false;
	errorMessage: string = "";

	////////////////////////////////////////////////////////////

	////////////////////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////////////////////

	loadExportColumns() {
		var IDDesc = "Student ID";
		if (this.Mode == "Staff") {
			IDDesc = "Staff ID";
		}

		this.lstExportColumns.push({
			ID: 1,
			Desc: IDDesc,
			DataField: "IDNumber",
			Visible: true,
		});

		this.lstExportColumns.push({
			ID: 2,
			Desc: "First Name",
			DataField: "FirstName",
			Visible: false,
		});

		this.lstExportColumns.push({
			ID: 3,
			Desc: "Last Name",
			DataField: "LastName",
			Visible: false,
		});

		if (this.Mode == "Staff") {
			this.lstExportColumns.push({
				ID: 4,
				Desc: "Staff Title",
				DataField: "StaffTitle",
				Visible: false,
			});
		}
		this.lstExportColumns.push({
			ID: 5,
			Desc: "File Name",
			DataField: "FileName",
			Visible: true,
		});

		this.UpdateCols();
	}

	loadExampleData() {
		for (var z = 0; z < 10; z++) {
			var nextIDNum = this.getRandomID();

			var next = {
				ID: z,
				IDNumber: nextIDNum,
				FirstName: this.getRandomStr(this.lstExFirstName),
				LastName: this.getRandomStr(this.lstExLastName),
				StaffTitle: this.getRandomStr(this.lstExStaffTitle),
				FileName: nextIDNum + ".jpg",
			};

			this.lstExampleData = [...this.lstExampleData, next];
		}

		console.log(this.lstExampleData);
	}

	getRandomID() {
		var num = Math.floor(Math.random() * Math.pow(10, 10));

		return String(num).padStart(10, "0");
	}

	getRandomStr(lstEx) {
		var ind = Math.floor(Math.random() * lstEx.length);
		return lstEx[ind];
	}

	////////////////////////////////////////////////////////////

	////////////////////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////////////////////

	onExport() {
		this.errorMessage = "";

		if (this.lstVisibleExportColumns.length == 0) {
			this.errorMessage =
				"No columns are selected. Pick which columns you want in the exported file by pressing the Visible checkbox. Drag and drop the columns into the order you want them in the file.";
			return;
		}

		this.Processing = true;

		var lstHdrs = this.lstVisibleExportColumns.map((col) => col.Desc);
		var lstDFs = this.lstVisibleExportColumns.map((col) => col.DataField);

		var parms: wsExportMapFileRequest = {
			Mode: this.Mode == "Student" ? 1 : 2,
			SchoolID: this.SelectedSchool.SchoolID,
			GroupID: this.SelectedStudentGroup == undefined ? -1 : this.SelectedStudentGroup.GroupID,
			lstHeaders: lstHdrs,
			lstDataFields: lstDFs,
			FileTypeID: this.FileTypeID,
		};

		var result = this.dataService.PhotoExportDownloadMapFile(parms);
		result.subscribe(
			(response: any) => {
				console.log(response);

				var a = document.createElement("a"); //Create <a>
				var FileName = response.FileName;
				a.href = "data:text/plain;base64," + response.FileB64;
				a.download = FileName;
				a.click(); //Downloaded file

				this.Processing = false;
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onClose() {
		this.ref.close(0);
	}

	////////////////////////////////////////////////////////////

	////////////////////////////////////////////////////////////
	// Events
	////////////////////////////////////////////////////////////

	onExportColDragDropped(ev) {
		console.log(ev);

		moveItemInArray(this.lstExportColumns, ev.previousIndex, ev.currentIndex);
		this.UpdateCols();
	}

	onVisibleChange() {
		this.UpdateCols();
	}

	////////////////////////////////////////////////////////////

	UpdateCols() {
		this.lstVisibleExportColumns = [];

		for (var z = 0; z < this.lstExportColumns.length; z++) {
			var next = this.lstExportColumns[z];

			if (next.Visible == true) {
				this.lstVisibleExportColumns = [...this.lstVisibleExportColumns, next];
			}
		}

		// this.ExamplePageRows = Number(this.ExamplePageRows);
	}
}
